module.exports = __webpack_public_path__ + "media/images/lp/1/support2-sp-4f979f74deafee42521a5ce15267be30.png";